module.exports = __webpack_public_path__ + "img/ico_home_smiles.5579580e.png";